import script from "./ScoreBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScoreBoard.vue?vue&type=script&setup=true&lang=ts"

import "./ScoreBoard.vue?vue&type=style&index=0&id=469e6589&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-469e6589"]])

export default __exports__